import React from "react";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Sidebar = ({ children, collapsed, toggle }) => {
  return (
    <div className={`sidebar_a ${collapsed ? " open" : ""}`}>
      <div className="sidebar_aa">
        <FontAwesomeIcon
          style={{cursor:"pointer"}}
          icon={faBars}
          className="toggle_btn"
          onClick={toggle}
          size="lg"
        />
      </div>
      {children}
    </div>
  );
};

export default Sidebar;
